import HTTP from './http'
const BASE_URL = '/account'

export default {
  async getDetailsByAccountKey(accountKey) {
    const response = await HTTP.get(`${BASE_URL}/${accountKey}`)
    return response.data.data
  },

  async getDetailsByEmail(accountEmailAddress) {
    const params = {
      accountEmailAddress
    }
    const response = await HTTP.get(`${BASE_URL}`, { params })
    return response.data.data
  },

  async getAccountByKey(accountKey) {
    const params = {
      accountKey
    }
    const response = await HTTP.get(`${BASE_URL}`, { params })
    return response.data.data
  },

  async update(accountDetails) {
    const payload = Object.assign({}, accountDetails)
    const response = await HTTP.put(`${BASE_URL}?accountEmailAddress=${accountDetails.accountEmailAddress}`, payload)
    return response.data.data
  }
}
